// extracted by mini-css-extract-plugin
export var backgroundImageWrapper = "minimalHero-module--background-image-wrapper--fdbb0";
export var content = "minimalHero-module--content--9681d";
export var desktopImage = "minimalHero-module--desktop-image--4d676";
export var image = "minimalHero-module--image--4e670";
export var minimalHero = "minimalHero-module--minimal-hero--93ae2";
export var mobileImage = "minimalHero-module--mobile-image--f3c25";
export var overlay = "minimalHero-module--overlay--2997f";
export var small = "minimalHero-module--small--26baa";
export var title = "minimalHero-module--title--9a229";